import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid, Typography, ThemeProvider, Paper } from "@material-ui/core";
import { addRegisteredLayout } from "../layoutDescriptions";
import { Panel } from "../../../panel";
import clsx from "clsx";
import { useStyles, actionsTheme, mainTheme } from "./styles";
const mainPanelSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true
    }
};
const panelSettings = {
    summaryHeader: {
        defaultOptions: {
            literal: true
        }
    },
    main: mainPanelSettings,
    actions: {}
};
addRegisteredLayout({
    name: "Vertical",
    displayName: "Vertical",
    panels: panelSettings
});
export const Vertical = (props) => {
    const { panels } = props;
    const { main, actions, summaryHeader } = panels;
    const verticalClasses = useStyles();
    const myActions = {
        ...actions,
        sections: [
            {
                formTemplateSectionId: "__myaction",
                fields: actions?.sections?.[0]?.fields?.filter(f => f.role !== "navigate_before") ?? []
            }
        ]
    };
    return (_jsx(_Fragment, { children: _jsx(Grid, { container: true, justifyContent: "center", children: main && (_jsx(Grid, { item: true, xs: 12, lg: 4, md: 8, children: _jsx(Paper, { elevation: 0, square: true, className: clsx(verticalClasses.mainGrid), children: _jsxs(Grid, { item: true, xs: 12, md: true, children: [props.pageTitle && (_jsx(ThemeProvider, { theme: mainTheme, children: _jsx(Typography, { variant: "h1", gutterBottom: true, className: verticalClasses.titleText, children: props.pageTitle }) })), summaryHeader.sections.length > 0 && (_jsx(ThemeProvider, { theme: mainTheme, children: _jsx(Panel, { ...summaryHeader, transparent: true, disableTabs: true, fullWidth: true }) })), _jsx(ThemeProvider, { theme: mainTheme, children: _jsx(Panel, { ...main, transparent: true, disableTabs: true, fullWidth: true }) }), _jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { ...myActions, transparent: true, disableTabs: true, fullWidth: true }) })] }) }) })) }) }));
};
Vertical.displayName = "DployFormVertical";
//# sourceMappingURL=Vertical.js.map